import { useEffect, useState, useCallback } from "react";
import { getValidationRerunResultByExecutionId } from "../services/resourcesService";
import { validationReRunMockData } from "../services/constants/resource";

interface FetchValidationRerunResultProps {
  currentExecutionId: number | null;
  setIsLoading: (loading: boolean) => void;
 
}

const useFetchValidationRerunResultByExecutionId = ({
  currentExecutionId,
  setIsLoading,
  
}: FetchValidationRerunResultProps) => {
  const [validationRerunResultData, setValidationRerunResultData] =
    useState<any>(null);

  const fetchRerunResult = useCallback(async () => {
    if (currentExecutionId) {
      setIsLoading(true);
      try {
        //on temp bases mock data is set
        // setValidationRerunResultData(validationReRunMockData);

        const result = await getValidationRerunResultByExecutionId(
          currentExecutionId
        );
        setValidationRerunResultData(result);
      } catch (error) {
        setValidationRerunResultData(null);
      } finally {
        setIsLoading(false);
      }
    }
  }, [currentExecutionId, setIsLoading]);

  useEffect(() => {
    fetchRerunResult();
  }, [fetchRerunResult]);

  return [validationRerunResultData];
};

export default useFetchValidationRerunResultByExecutionId;
